import { useState } from 'react';
import { UpdateAccountContactsRequest } from 'vopay';
import { api } from '@/services/api.config';

/**
 * Saves an account's contact information (`POST /account/profile/update-contact`) with the
 * account's own bearer. The route is a partial update: only the fields sent are written, and a
 * blank value leaves the stored one as it is, so callers send what changed.
 */
export default function useUpdateAccountContacts() {
  const [updatingAccountContacts, setUpdatingAccountContacts] = useState(false);

  async function updateAccountContacts(params: UpdateAccountContactsRequest, bearer: string) {
    try {
      setUpdatingAccountContacts(true);

      const res = await api.updateAccountContacts(params, bearer);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setUpdatingAccountContacts(false);
    }
  }

  return { updatingAccountContacts, updateAccountContacts };
}
